"use strict";

($dt => {

	const { convert_egalaxy_date } = $dt.TopicGrid.Functions;

	/**
	 * Time selection screen.
	 * 
	 * @param {Block} block 
	 * @param {InnerScreen} inner_screen 
	 * @param {*} controller 
	 */
	$dt.TopicGrid.ScreenFunctions.o0_i4 = (block, inner_screen, controller) => {
		// Select time, next button requires selection of time,
		
		const { inner_elem } = inner_screen;
		const [ button_next_elem, button_prev_elem, select_times_elem, selected_date_label ] = [
			inner_elem.querySelector('.button-next'),
			inner_elem.querySelector('.button-prev'),
			inner_elem.querySelector('.select-time'),
			inner_elem.querySelector('.selected-date')
		];

		inner_screen.Show = () => {
			let found_time = false;
			const { scheduling_info } = block;
			const { available_times } = scheduling_info;

			// Empty previous times if any
			select_times_elem.innerHTML = '';

			// Set selected date label
			selected_date_label.innerHTML = convert_egalaxy_date(scheduling_info.selected_date);

			if (available_times.length === 0) {
				// No times available - shouldn't be possible to arrive here
			} else {
				const button_list_elem = document.createElement('ul');
				const all_button_elems = [];
				
				available_times.forEach(ev_time => {
					const [ item_elem, button_elem, span_elem ] = [
						document.createElement('li'),
						document.createElement('a'),
						document.createElement('span')
					];

					span_elem.innerText = ev_time.start_time;

					if (scheduling_info.selected_time && scheduling_info.selected_time === ev_time.start_time) {
						found_time = true;
						button_elem.classList.add('active');
					}

					button_elem.setAttribute('href', '#');
					button_elem.addEventListener('click', e => {
						e.preventDefault();
						
						// Toggle button class
						all_button_elems.forEach(curr_btn => {
							if (curr_btn === button_elem) {
								curr_btn.classList.add('active');
							} else {
								curr_btn.classList.remove('active');
							}
						});

						// Set event ID
						scheduling_info.selected_event_id = ev_time.eventid;
						scheduling_info.selected_time = ev_time.start_time;

						// Allow next button click
						button_next_elem.removeAttribute('disabled');
					});

					all_button_elems.push(button_elem);
					button_elem.appendChild(span_elem);
					item_elem.appendChild(button_elem);
					button_list_elem.appendChild(item_elem);
				});
				select_times_elem.appendChild(button_list_elem);
			}

			if (!found_time) {
				scheduling_info.selected_time = false;
			}
			
			if (!scheduling_info.selected_time) {
				button_next_elem.setAttribute('disabled', '');
			}
		};

		button_prev_elem.addEventListener('click', () => {
			const { current_screen, scheduling_info } = block;
			current_screen.inner = 3;
			controller.SetScreenUI(block);

			// Reset Times & Selected Date
			select_times_elem.innerHTML = '';
			scheduling_info.selected_event_id = false;
			scheduling_info.selected_date = false;
			scheduling_info.selected_time = false;
			scheduling_info.available_times = [];
			button_next_elem.setAttribute('disabled', '');

			// Refresh calendar
			controller.UpdateCalendar(block);
		});

		button_next_elem.addEventListener('click', () => {
			const { current_screen, scheduling_info, contact_info } = block;

			if (scheduling_info.selected_event_id) {
				// If not logged in, we send the user to anonymous contact info collect screen
				if (contact_info.anon) {
					current_screen.outer = 1;
					current_screen.inner = 0;
				} else {
					current_screen.inner = 5;
				}
				controller.SetScreenUI(block);
			}
		});
	};

})(window.d3_wp_themejs);
